export const GENERIC_VALIDATION_ERROR =
  'There was a problem with your submission. Please correct any errors and try again.';
export const GENERIC_API_ERROR =
  'Something went wrong! Please try again or contact support if the problem continues.';
export const GENERIC_REQUEST_ERROR =
  'Something is wrong with your connection to the server. Please try again or contact support if the problem continues.';
